<a
  [ngClass]="class"
  [class.disable-underline]="!isSales"
  [class.p-0]="isSales"
  (click)="isSales ? openModal() : undefined"
  [innerHTML]="status"
></a>
